import { bold, Summary } from './primitives';
import type { SummarySlice } from './types';

export const partSummaries = {
  'part.added': ({ ctx }) => <Summary>{bold(ctx.targetName)}&nbsp;part added</Summary>,

  'part.edited': ({ ctx }) => <Summary>{bold(ctx.targetName)}&nbsp;part edited</Summary>,

  'part.removed': ({ ctx }) => <Summary>{bold(ctx.targetName)}&nbsp;part removed</Summary>,

  'part.moved': ({ ctx }) => <Summary>{bold(ctx.targetName)}&nbsp;part moved</Summary>,

  'part.swapped': ({ entry, ctx }) => {
    const swappedTargetName = entry.target?.name || ctx.sectionLabel(entry.target?.id) || null;
    const otherName = entry.other.name || ctx.sectionLabel(entry.other.id) || null;
    return (
      <Summary>
        Positions of the parts&nbsp;{bold(swappedTargetName)}&nbsp;and&nbsp;{bold(otherName)}&nbsp;swapped
      </Summary>
    );
  },

  'part.renamed': ({ entry }) => (
    <Summary>
      {bold(entry.from)}&nbsp;part renamed to&nbsp;{bold(entry.to)}
    </Summary>
  ),
} satisfies SummarySlice;
